import {
  requiredElement,
  emailValidElement,
} from "@/services/ValidatorService";

export const userPasswordRecoveryForm = {
  email: {
    value: "",
    props: {
      type: "email",
    },
    rules: [requiredElement, emailValidElement],
  },
};
